<template>
  <div class="terms-of-exchange-and-refund-container text-white text-start">
    <div class="layout__content">
      <h1 class="page-headding heading" style="font-size: calc(1rem + 3vw);" >Условия обмена и возврата</h1>
    </div>
    <div class="layout">
      <div class="layout__content">
        <div class="w-big-screen">
          <p>Наш интернет-магазин работает в строгом соответствии с&nbsp;<strong>Законом &laquo;О защите прав потребителей&raquo;</strong>.</p>
          <p>Согласно ст. 25 Закона &laquo;О защите прав потребителей&raquo;, вы можете вернуть или обменять товар&nbsp;<strong>надлежащего</strong>&nbsp;качества, приобретённый в розничном магазине, в течение 14 дней, не считая дня покупки.</p>
          <p>Согласно ст. 26.1 Закона &laquo;О защите прав потребителей&raquo;, вы вправе вернуть&nbsp;<strong>любой</strong>&nbsp;товар, приобретённый в интернет-магазине, в течение семи дней после получения товара без указания причин возврата.</p>
          <p>Возврат товара надлежащего качества возможен в случае, если&nbsp;<strong>сохранены его товарный вид, потребительские свойства, а также документ, подтверждающий факт и условия покупки указанного товара</strong>. Отсутствие у потребителя документа, подтверждающего факт и условия покупки товара, не лишает его возможности ссылаться на другие доказательства приобретения товара у данного продавца.</p>
          <p>Потребитель не вправе отказаться от товара надлежащего качества, имеющего индивидуально-определенные свойства, если указанный товар может быть использован исключительно приобретающим его потребителем (<em>прим.: если товар изготовлен на заказ</em>).</p>
          <p>При отказе потребителя от товара продавец должен возвратить ему денежную сумму, уплаченную потребителем по договору, за исключением расходов продавца на доставку от потребителя возвращенного товара, не позднее чем через десять дней со дня предъявления потребителем соответствующего требования.</p>
          <div class="background-container ps-1 pe-3" >
            <p class="header-font-size" style="">Контакты для связи с магазином по вопросам обмена или возврата товаров:</p>
            <p>Email:&nbsp;<span>site@</span><span>addgrill.com</span></p>
            <p>Телефон: +7 (861) 204-70-10</p>
            <p>Адрес: Адрес: 350059, Краснодарский край, г. Краснодар, улица Новороссийская, 210</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (min-width: 1101px) {
  .w-big-screen{
    width: 50%!important;
  }
  .background-container{
    background-image: linear-gradient(to top, #ED5500FF 89%, transparent 0%);
    width: auto;
  }
  .header-font-size{
    font-size: calc(1rem + 0.85vw);
  }
}
@media (max-width: 600px) {
  .mt-app-header{
    margin: 15% 2% 2% !important;
  }
  .background-container{
    background-image: linear-gradient(to top, #ED5500FF 94%, transparent 0%);
    width: auto;
  }
  .header-font-size{
    font-size: calc(1rem + 0.4vw);
  }
}
@media (max-width: 849px) and (min-width: 601px){
  .mt-app-header{
    margin: 8% 2% 2% !important;
  }
  .background-container{
    max-width: 70%!important;
    background-image: linear-gradient(to top, #ED5500FF 92%, transparent 0%);
    width: auto;
  }
  .header-font-size{
    max-width: 90%!important;
    font-size: calc(1rem + 0.8vw);
  }
}
@media (max-width: 1100px) and (min-width: 850px){
  .mt-app-header{
    margin: 8% 2% 2% !important;
  }
  .background-container{
    max-width: 70%!important;
    background-image: linear-gradient(to top, #ED5500FF 90%, transparent 0%);
    width: auto;
  }
  .header-font-size{
    max-width: 70%!important;
    font-size: calc(1rem + 0.8vw);
  }
}


</style>
